export default "__VITE_ASSET__Fv9wIixL__"